export default "__VITE_ASSET__BjneO7KP__"